"use client"

import SocialShareButtons from "@/components/post-detail/SocialShareButtons"
import { EventData } from "@/types/event"
import { EventDetailSection } from "./EventDetailSection"

interface EventDetailContentProps {
    event: EventData
}

export const EventDetailContent = ({ event }: EventDetailContentProps) => {
    const shareUrl = typeof window !== 'undefined' ? window.location.href : undefined

    return (
        <div className="flex flex-col gap-4 sm:w-[59.4%] w-full">
            <EventDetailSection detail={event?.attributes?.detail} />
            <SocialShareButtons facebook={shareUrl} twitter={shareUrl} />
        </div>
    )
}

